<section class="bg-secondary pt-5">
  <div class="container py-4 py-lg-5">
    <div class="row">
      <div class="col-md-4 text-center text-md-start">
        <h2 class="h1">Intrebari? Verifica lista de intrebari frecvente</h2>
        <!-- <p class="pb-3 pb-sm-4">Et felis vitae ac venenatis lacus cras etiam risus scelerisque auctor adipiscing in a
          porta</p> -->
        <div class="d-none d-md-flex justify-content-center">
          <svg class="text-warning ms-n4" width="200" height="211" viewBox="0 0 200 211" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M198.804 194.488C189.279 189.596 179.529 185.52 169.407 182.07L169.384 182.049C169.227 181.994 169.07 181.939 168.912 181.884C166.669 181.139 165.906 184.546 167.669 185.615C174.053 189.473 182.761 191.837 189.146 195.695C156.603 195.912 119.781 196.591 91.266 179.049C62.5221 161.368 48.1094 130.695 56.934 98.891C84.5539 98.7247 112.556 84.0176 129.508 62.667C136.396 53.9724 146.193 35.1448 129.773 30.2717C114.292 25.6624 93.7109 41.8875 83.1971 51.3147C70.1109 63.039 59.63 78.433 54.2039 95.0087C52.1221 94.9842 50.0776 94.8683 48.0703 94.6608C30.1803 92.8027 11.2197 83.6338 5.44902 65.1074C-1.88449 41.5699 14.4994 19.0183 27.9202 1.56641C28.6411 0.625793 27.2862 -0.561638 26.5419 0.358501C13.4588 16.4098 -0.221091 34.5242 0.896608 56.5659C1.8218 74.6941 14.221 87.9401 30.4121 94.2058C37.7076 97.0203 45.3454 98.5003 53.0334 98.8449C47.8679 117.532 49.2961 137.487 60.7729 155.283C87.7615 197.081 139.616 201.147 184.786 201.155L174.332 206.827C172.119 208.033 174.345 211.287 176.537 210.105C182.06 207.125 187.582 204.122 193.084 201.144C193.346 201.147 195.161 199.887 195.423 199.868C197.08 198.548 193.084 201.144 195.528 199.81C196.688 199.192 197.846 198.552 199.006 197.935C200.397 197.167 200.007 195.087 198.804 194.488ZM60.8213 88.0427C67.6894 72.648 78.8538 59.1566 92.1207 49.0388C98.8475 43.9065 106.334 39.2953 114.188 36.1439C117.295 34.8947 120.798 33.6609 124.168 33.635C134.365 33.5511 136.354 42.9911 132.638 51.031C120.47 77.4222 86.8639 93.9837 58.0983 94.9666C58.8971 92.6666 59.783 90.3603 60.8213 88.0427Z"
              fill="currentColor"></path>
          </svg>
        </div>
      </div>
      <div class="col-md-8 col-lg-7 offset-lg-1">
        <div ngbAccordion [closeOthers]="true">
          <div ngbAccordionItem [collapsed]="false" class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Ce
                este GiftShare?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  GiftShare.ro este
                  <i>prima</i> platforma din Romania cu ajutorul careia prietenii, colegii si rudele pot
                  contribui online la cadoul tau perfect. De ce este perfect? Pentru ca il alegi chiar tu! In plus, pe
                  GiftShare.ro poti chiar sa alegi sa-ti donezi momentul special si cadoul primit unei cauze sociale.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cand este util GiftShare?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  <p>Indiferent de
                    evenimentul sarbatorit, fie ca este vorba de aniversarea unui coleg sau prieten, o petrecere de casa
                    noua, o cununie, un babyshower sau botez, cu GiftShare este foarte simplu sa faceti un cadou de
                    grup. Si nu orice cadou... cadoul perfect!</p>
                  <p>De asemenea, companiile pot folosi GiftShare pentru a oferi angajatilor flexibilitatea de a-si
                    alege
                    beneficiul perfect de la cele peste {{(systemStatistics$ | async)?.voucherNonCharityCount}} magazine
                    partenere.</p>
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cum pot oferi un cadou de grup (Cheta Digitala)?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  <p>Este atat de simplu
                    sa oferi cadoul perfect, in doar 4 pasi!</p>
                  <ol>
                    <li>Creezi evenimentul</li>
                    <li>Inviti & distribui</li>
                    <li>Colectezi fondurile</li>
                    <li>Sarbatoritul isi alege cadoul perfect de le cele peste {{(systemStatistics$ |
                      async)?.voucherNonCharityCount}} magazine partenere GiftShare.</li>
                  </ol>
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cum
                creez un eveniment?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Primul pas este sa
                  creezi un cont de utilizator si sa te loghezi. Acolo vei gasi toate informatiile necesare
                  pentru crearea evenimentului si pentru personalizarea paginii.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cum
                promovez un eveniment?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Trimiti link-ul
                  paginii tale de eveniment colegilor si prietenilor prin orice canal de comunicare ai la
                  dispozitie (email, Facebook, Twitter, WhatsApp, Messenger, etc).
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Evenimentele sunt publice?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Atunci cand creezi
                  un eveniment, ai posibilitatea sa alegi daca vrei sa fie public sau privat.
                  In general, evenimentele publice sunt cele cu un scop caritabil.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cat
                timp dureaza un eveniment?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Tu stabilesti
                  perioada de desfasurare a unui eveniment si suma pe care iti propui sa o strangi prin intermediul
                  acestuia. Perioada optima de a incepe campania pentru un eveniment este cu minimum o saptamana
                  inainte ca acesta sa aiba loc.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Este obligatoriu sa specific suma dorita pentru cadou?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Specifici suma
                  propusa doar daca doresti, acest lucru nu este obligatoriu.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Pot
                modifica durata evenimentului sau suma dorita pentru cadouri?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Da, poti modifica
                  perioada de desfasurare a evenimentului sau suma pe care iti doresti sa o colectezi pentru
                  cadou oricand, din pagina evenimentului.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cum contribuie colegii si prietenii?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Plata sumelor de
                  bani cu care colegii si prietenii vor sa contribuie se face prin card bancar, fiind protejata si
                  securizata in sistem 3D Secure. Toate platile sunt derulate prin procesatorul de plati
                  <a href="http://www.mobilpay.ro/public/" target="_blank">MobilPay.ro</a>.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Daca am stabilit o suma dorita, ce se intampla daca nu este atinsa?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Nu-i nimic daca nu
                  s-a atins targetul propus la crearea evenimentului. Sarbatoritul va avea acces la suma stransa
                  pentru a-si alege cadoul perfect.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cum pot folosi suma primita cadou?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Cu banii stransi
                  de la cei dragi, poti fie sa cumperi unul sau mai multe carduri cadou de la partenerii
                  GiftShare, fie sa daruiesti momentul tau special si, implicit, cadoul, unei cauze sociale (donatie
                  catre
                  un ONG).
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Pot transfera banii primiti intr-un cont sau card bancar?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Banii stransi prin
                  intermediul evenimentului creat pe site-ul GiftShare.ro pot fi folositi exclusiv pentru
                  achizitionarea unor carduri cadou de la partenerii GiftShare.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Cat de repede pot intra in posesia cardurilor cadou?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Odata ce ai ales
                  cardul sau cardurile cadou dorite din lista partenerilor GiftShare, acestea iti vor fi
                  livrate in format electronic pe mail in maximum 2 zile lucratoare, in functie de disponibilitatea
                  partenerilor.
                  Apoi le poti folosi oricand pentru a-ti achizitiona cadoul dorit din magazinele
                  partenerilor.
                  Pentru fiecare card cadou achizitionat te rugam sa verifici conditiile de utilizare aferente
                  partenerilor.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                GiftShare este gratuit?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Crearea de
                  evenimente pe GiftShare si alegerea cadoului perfect sunt 100% gratuite!
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Care este varsta minima pentru a putea deschide un cont GiftShare?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  Pentru a deschide
                  un cont GiftShare si pentru a putea crea evenimente, varsta minima necesara este de 16
                  ani.
                </ng-template></div>
            </div>
          </div>
          <div ngbAccordionItem class="bg-light">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                Am
                primit un card cadou GiftShare de la prieteni, cum il pot folosi?
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="fs-sm"><ng-template>
                  <p>Daca ai primit din partea prietenilor un cadou de grup prin GiftShare, este foarte simplu sa-ti
                    alegi cadoul perfect!</p>
                  <ol>
                    <li>Creeaza-ti un cont GiftShare.</li>
                    <li>Introduci codul cardului cadou in meniul "Aplica un card GiftShare" si balanta ta GiftShare va
                      fi
                      actualizata.
                    </li>
                    <li>Iti alegi cadoul perfect de la peste {{(systemStatistics$ | async)?.voucherNonCharityCount}}
                      magazine partenere GiftShare prin comandarea unuia
                      sau mai multor carduri cadou la parteneri, acestea fiind folosite la achitarea partiala sau
                      totala
                      a produselor alese de la respectivii parteneri.</li>
                  </ol>
                </ng-template></div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</section>

<section class="bg-secondary">
  <div class="container pb-1 pb-md-0 px-4 px-sm-3">
    <div class="row">
      <div class="card bg-primary overflow-hidden py-2 py-sm-3 py-md-4 mb-sm-2 mb-md-4">
        <div class="bg-dark position-absolute top-0 start-0 w-100 h-100 opacity-5"></div>
        <div class="position-absolute top-0 start-0 w-100 h-100 opacity-15"
          style="background-image: url(assets/images/resource/noise.png); mix-blend-mode: soft-light;"></div>
        <div
          class="card-body position-relative d-sm-flex align-items-center justify-content-between zindex-2 text-center">
          <div class="d-md-flex align-items-center pe-md-4">
            <div class="d-none d-md-block text-warning flex-shrink-0 me-3">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 0L12.6798 4.12733C13.2879 7.81883 16.1812 10.7121 19.8727 11.3202L24 12L19.8727 12.6798C16.1812 13.2879 13.2879 16.1812 12.6798 19.8727L12 24L11.3202 19.8727C10.7121 16.1812 7.81882 13.2879 4.12733 12.6798L0 12L4.12733 11.3202C7.81883 10.7121 10.7121 7.81882 11.3202 4.12733L12 0Z">
                </path>
              </svg>
            </div>
            <h2 class="text-light pb-1 pb-md-0 mb-md-0">Intrebarea ta nu se regaseste in lista de mai sus?</h2>
          </div><a [routerLink]="['/contact']" class="btn btn-lg btn-warning me-xl-4">Contacteaza-ne</a>
        </div>
      </div>
    </div>
  </div>
</section>
